import { usePermisos } from '../context/UserContext';
import SinAcceso from '../pages/SinAcceso';

/**
 * Protege una ruta exigiendo permiso de "ver" en un módulo.
 * Uso: <PermisoRoute modulo="leche"><MiPagina /></PermisoRoute>
 */
export default function PermisoRoute({ modulo, children }) {
  const { puedeVer } = usePermisos();
  if (!puedeVer(modulo)) return <SinAcceso />;
  return children;
}
